import{defineMessages}from'react-intl';

export default defineMessages({
title_default:{
id:'confirmation_modal.title_default',
defaultMessage:'Are you sure?'},

button_cancel:{
id:'confirmation_modal.button_cancel',
defaultMessage:'Cancel'},

button_confirm:{
id:'confirmation_modal.button_confirm',
defaultMessage:'Confirm'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL0NvbmZpcm1hdGlvbk1vZGFsL0NvbmZpcm1hdGlvbk1vZGFsLm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwidGl0bGVfZGVmYXVsdCIsImlkIiwiZGVmYXVsdE1lc3NhZ2UiLCJidXR0b25fY2FuY2VsIiwiYnV0dG9uX2NvbmZpcm0iXSwibWFwcGluZ3MiOiJBQUFBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLGNBQWU7QUFDYkMsR0FBSSxrQ0FEUztBQUViQyxlQUFnQixlQUZILENBRGE7O0FBSzVCQyxjQUFlO0FBQ2JGLEdBQUksa0NBRFM7QUFFYkMsZUFBZ0IsUUFGSCxDQUxhOztBQVM1QkUsZUFBZ0I7QUFDZEgsR0FBSSxtQ0FEVTtBQUVkQyxlQUFnQixTQUZGLENBVFksQ0FBZixDQUFmIiwiZmlsZSI6IkNvbmZpcm1hdGlvbk1vZGFsLm1lc3NhZ2VzLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBkZWZpbmVNZXNzYWdlcyB9IGZyb20gJ3JlYWN0LWludGwnO1xuXG5leHBvcnQgZGVmYXVsdCBkZWZpbmVNZXNzYWdlcyh7XG4gIHRpdGxlX2RlZmF1bHQ6IHtcbiAgICBpZDogJ2NvbmZpcm1hdGlvbl9tb2RhbC50aXRsZV9kZWZhdWx0JyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0FyZSB5b3Ugc3VyZT8nLFxuICB9LFxuICBidXR0b25fY2FuY2VsOiB7XG4gICAgaWQ6ICdjb25maXJtYXRpb25fbW9kYWwuYnV0dG9uX2NhbmNlbCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdDYW5jZWwnLFxuICB9LFxuICBidXR0b25fY29uZmlybToge1xuICAgIGlkOiAnY29uZmlybWF0aW9uX21vZGFsLmJ1dHRvbl9jb25maXJtJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0NvbmZpcm0nLFxuICB9LFxufSk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmationModal/ConfirmationModal.messages.js
// module id = 2033
// module chunks = 0